import React from "react";
import ReactDOM from "react-dom";
import App from "containers/App";
import "./index.scss";

//Page component contains app routing between pages

ReactDOM.render(<App />, document.getElementById("root"));
